import { disasterModeAnswerCatalog, disasterModeContentStates } from "@safesphere/contracts";
const answerStates = disasterModeContentStates.filter((state) => state !== "COMPLETE");
function cartesian(options) {
    return options.reduce((paths, answers) => paths.flatMap((path) => answers.map((answer) => [...path, answer])), [[]]);
}
export function enumeratePermittedRoutes() {
    return cartesian(answerStates.map((state) => disasterModeAnswerCatalog[state])).map((answers, index) => ({ id: `route-${String(index + 1).padStart(2, "0")}`, answers }));
}
function bindingId(recordIndex, bindingIndex) {
    return `record-${String(recordIndex)}:binding-${String(bindingIndex)}`;
}
function applies(binding, path) {
    return (binding.answerPath.length <= path.length &&
        binding.answerPath.every((answer, index) => path[index] === answer));
}
export function previewCoverage(records) {
    const routes = enumeratePermittedRoutes();
    const selected = new Set();
    const cells = [];
    for (const route of routes) {
        for (const [stateIndex, state] of disasterModeContentStates.entries()) {
            const path = route.answers.slice(0, Math.min(stateIndex, route.answers.length));
            const candidates = records.flatMap((record, recordIndex) => record.bindings.flatMap((binding, bindingIndex) => binding.state === state && applies(binding, path)
                ? [{ binding, id: bindingId(recordIndex, bindingIndex) }]
                : []));
            candidates.sort((left, right) => right.binding.answerPath.length - left.binding.answerPath.length);
            const winner = candidates[0];
            if (winner !== undefined)
                selected.add(winner.id);
            cells.push({
                routeId: route.id,
                state,
                answerPath: path,
                ...(winner === undefined ? {} : { bindingId: winner.id }),
            });
        }
    }
    const allBindings = records.flatMap((record, recordIndex) => record.bindings.map((_binding, bindingIndex) => bindingId(recordIndex, bindingIndex)));
    return { routes, cells, unreachableBindingIds: allBindings.filter((id) => !selected.has(id)) };
}
